
AOS.init({
  easing: 'ease-in-out',
  once: true
});

window.addEventListener('load', function() {
  AOS.refresh();
});
